import { createStatusOptions } from '@/config/statusOptions';

// `access_status` — an account user's own status; a pending invitee is a user too.

export const ACCESS_STATUS = Object.freeze({
  active: 'ACTIVE',
  pendingInvitation: 'PENDING_INVITATION',
  removedAccess: 'REMOVED_ACCESS',
});

export const ACCESS_STATUS_LABEL_KEYS = Object.freeze({
  [ACCESS_STATUS.active]: 'STATUS_ACCESS_ACTIVE',
  [ACCESS_STATUS.pendingInvitation]: 'STATUS_ACCESS_PENDING_INVITATION',
  [ACCESS_STATUS.removedAccess]: 'STATUS_ACCESS_REMOVED',
});

export const { statusLabel: accessStatusLabel, buildStatusVariants: buildAccessStatusVariants } =
  createStatusOptions(ACCESS_STATUS_LABEL_KEYS);
